import { useEffect, useState } from 'react';
import axios from 'axios';

interface Bookmark {
  userId: string;
  part_number: string;
  model_name: string;
  title: string;
  url: string;
}

const useBookmarks = (userId: string) => {
  const [bookmarks, setBookmarks] = useState<Bookmark[]>([]);

  useEffect(() => {
    const fetchBookmarks = async () => {
      const projectParams = {
        action: 'get_bookmarks',
        userId: userId,
      };

      try {
        const response = await axios.post(
          `https://pssoftgroup.com/demo/infindbot/index.php?timestamp=${Date.now()}`,
          projectParams
        );
        const projectArray = response.data.bookmarks
        ? Object.values(response.data.bookmarks) as Bookmark[]
        : [];
        if (response.data.bookmarks) {
          setBookmarks(projectArray);
        } 
       } catch (error:any) {
        console.error('Error fetching projects:', error.message);
      }
    };

    fetchBookmarks();
  }, [userId]);

  return bookmarks;
};

export default useBookmarks;
